import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Fab from "@material-ui/core/Fab";
import SendIcon from "@material-ui/icons/Send";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles({
  chatSection: {
    width: "100%",
    height: "60vh",
  },
  messageArea: {
    height: "70vh",
    overflowY: "auto",
  },
});

const Chat = ({ open, onClose }) => {
  const classes = useStyles();
  const [message, setMessage] = useState("");
  const [chat, setChat] = useState([
    { from: "AI", msg: "Hey man, What's up", time: "10:00" },
    { from: "ME", msg: "Hey man, whatever", time: "10:01" },
    { from: "ME", msg: "ok go away", time: "11:01" },
  ]);

  function handleChange(event) {
    setMessage(event.target.value);
  }

  function keyPress(e) {
    if (e.keyCode === 13) {
      addMessage("ME", message);
    }
  }

  function addMessage(from, msg) {
    if (msg.trim() === "") return;
    const time = new Date().toLocaleTimeString().slice(0, 5);
    setChat([...chat, { from, msg, time }]);
    setMessage("");
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Chat With User</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <List className={classes.messageArea}>
              {chat.map((c, i) => (
                <ListItem key={i}>
                  <Grid container>
                    <Grid item xs={12}>
                      <ListItemText align={c.from === "AI" ? "left" : "right"} primary={c.msg} />
                    </Grid>
                    <Grid item xs={12}>
                      <ListItemText
                        align={c.from === "AI" ? "left" : "right"}
                        secondary={c.from + " at " + c.time}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              ))}
            </List>
            <Divider />
            <Grid container style={{ padding: "20px" }}>
              <Grid item xs={11}>
                <TextField
                  id="outlined-basic-email"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  onChange={handleChange}
                  onKeyDown={keyPress}
                  value={message}
                  label="Type Something"
                  fullWidth
                />
              </Grid>
              <Grid item xs={1} align="right">
                <Fab color="primary" onClick={() => addMessage("ME", message)} aria-label="send">
                  <SendIcon />
                </Fab>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default Chat;
